var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurValues3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.763,
    height: 80.25,
    viewBox: "0 0 78.763 80.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:#fff}.cls-1{stroke:#345e86;stroke-width:.5px}.cls-3{stroke:#335c84;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    transform: "translate(-367.648 -1188.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(436.898 1077.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    d: "M3.65 123.689H1.964v1.964H0v1.686h1.964v1.961H3.65v-1.964h1.964v-1.686H3.65z",
    className: "cls-1",
    transform: "translate(367.898 1127.353)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(278.309 1080.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    d: "M159.055 173.895v1.686h-1.686v-1.686zm0 3.372v1.686h-1.686v-1.686z",
    className: "cls-2",
    transform: "translate(216.309 1030.297)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "team_1_",
    transform: "translate(361.814 1189.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    transform: "translate(72.492 50.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1535"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1043",
    cx: 1.528,
    cy: 1.528,
    r: 1.528,
    className: "cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1538",
    transform: "translate(14.312 50.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1537"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1044",
    cx: 1.528,
    cy: 1.528,
    r: 1.528,
    className: "cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1540",
    transform: "translate(7.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    d: "M82.068 75.193H68.943l-.08-37.562a1.528 1.528 0 0 0-1.528-1.525 1.528 1.528 0 0 0-1.525 1.532l.08 37.555h-4.44l-.039-16.712a1.528 1.528 0 0 0-1.528-1.525 1.528 1.528 0 0 0-1.525 1.532l.039 16.7h-3.719V54.964a8.386 8.386 0 0 0 7.729-8.255V31.9a16.592 16.592 0 0 0-1.456-6.8 12.653 12.653 0 0 1 7.99 3.517 11.848 11.848 0 0 1 3.679 8.553l.028 8.7a1.529 1.529 0 0 0 1.528 1.524h.005a1.529 1.529 0 0 0 1.519-1.535l-.028-8.7a14.881 14.881 0 0 0-4.612-10.745 15.624 15.624 0 0 0-5.9-3.582A8.082 8.082 0 0 0 59.6 8.891h-.017a8.114 8.114 0 0 0-3.729.919 1.529 1.529 0 1 0 1.418 2.709 4.974 4.974 0 0 1 2.318-.57 5.031 5.031 0 1 1 .022 10.061 1.524 1.524 0 0 0-.194.014l-.244.011a17.4 17.4 0 0 0-8.84-6.328 8.967 8.967 0 1 0-11.535.234 17.379 17.379 0 0 0-8.145 6.085c-.242-.011-.484-.017-.724-.017H29.504a5.031 5.031 0 1 1 2.4-9.454 1.529 1.529 0 0 0 1.46-2.686 8.085 8.085 0 0 0-9.169 13.2A15.225 15.225 0 0 0 14.312 37.2v8.669a1.529 1.529 0 1 0 3.057 0V37.2a12.319 12.319 0 0 1 11.485-12.087A16.592 16.592 0 0 0 27.4 31.9v14.809a8.393 8.393 0 0 0 7.986 8.275v20.21h-4.16v-16.71a1.529 1.529 0 1 0-3.057 0v16.709h-3.758V37.65a1.529 1.529 0 1 0-3.057 0v37.543H9.229a1.529 1.529 0 1 0 0 3.057h72.84a1.529 1.529 0 1 0 0-3.057zM38.512 8.967a5.91 5.91 0 1 1 5.91 5.91 5.917 5.917 0 0 1-5.91-5.91zm14.637 21.915a1.529 1.529 0 0 0-1.529 1.529v42.782h-5.444V53.927a1.529 1.529 0 1 0-3.057 0v21.266h-4.671V32.411a1.529 1.529 0 1 0-3.057 0v19.508a5.325 5.325 0 0 1-4.929-5.21V31.9a13.576 13.576 0 0 1 2.225-7.447 14.716 14.716 0 0 1 24.449.017 13.577 13.577 0 0 1 2.214 7.43v14.809a5.313 5.313 0 0 1-4.671 5.18V32.411a1.529 1.529 0 0 0-1.53-1.529z",
    className: "cls-3",
    transform: "translate(-7.7)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurValues3);
export default __webpack_public_path__ + "static/media/Our_Values_3.6b51fc7461d01c7111b229869fe9967f.svg";
export { ForwardRef as ReactComponent };